// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageWrapper":"ImageWithCaption-a08eea115b212623","image":"ImageWithCaption-2a8611a80d76f56b","caption":"ImageWithCaption-75602771379d541b"};